import { css, useTheme } from '@emotion/react'
import { matchPath } from 'react-router'
import { observer, inject } from 'mobx-react'

import { SVGWrapper } from '../../../../components'
import { BullsEye } from '../../../../assets/icons'
import { numberToDollars, withRouterProps } from '../../../../utils'
import {
  AccountGoalBox,
  BalanceSD,
  LabelSD,
  MainSideBarLabel,
  RowSD,
  SideDrawerAddButton,
  SideDrawerButtonWrapper,
} from './'

function SideDrawerGoals(props) {
  const theme = useTheme()
  const defaultFill = theme.svgSideBarDrawerFill

  const buildGoalsDisplay = goals => {
    const { navigate, location } = props

    return goals.map(goal => {
      return (
        <AccountGoalBox
          isHighlighted={!!matchPath({ path: `/goals/${goal.id}` }, location.pathname)}
          key={goal.id}
          onClick={() => navigate(`/goals/${goal.id}`)}
          id={'sidebar-goal-' + goal.id}>
          <RowSD>
            <LabelSD>{goal.name}</LabelSD>
          </RowSD>
          <RowSD>
            <BalanceSD
              isHighlighted={!!matchPath({ path: `/goals/${goal.id}` }, location.pathname)}>
              ${numberToDollars(goal.totalRemaining, true)}
            </BalanceSD>
          </RowSD>
        </AccountGoalBox>
      )
    })
  }
  const { navigate, location } = props
  const {
    currentGoals,
    person: { retirementIncomeGoalPct },
    features,
    config: { isSpendown, spendDownModeling },
  } = props.store
  const goals = buildGoalsDisplay(currentGoals)

  return (
    <div>
      <MainSideBarLabel
        isHighlighted={!!matchPath({ path: '/goals', end: true }, location.pathname)}
        onClick={() => navigate('/goals')}>
        <SVGWrapper
          css={css`
            display: flex;
            justify-content: flex-start;
            align-items: center;
            & span {
              width: 20px;
              height: 22px;
            }
          `}
          margin='4px'
          svg={BullsEye}
          size='mediumLarge'
          fill={defaultFill}
        />
        Goals
      </MainSideBarLabel>
      {!isSpendown && !spendDownModeling && (
        <AccountGoalBox
          isHighlighted={!!matchPath({ path: '/goals/replace-income' }, location.pathname)}
          onClick={() => navigate('/goals/replace-income')}>
          <RowSD>
            <LabelSD>Percent of income seeking after retiring</LabelSD>
          </RowSD>
          <RowSD>
            <BalanceSD
              isHighlighted={!!matchPath({ path: '/goals/replace-income' }, location.pathname)}>
              {numberToDollars(retirementIncomeGoalPct, true)}%
            </BalanceSD>
          </RowSD>
        </AccountGoalBox>
      )}
      {goals}
      {features.allowAddGoals && (
        <SideDrawerButtonWrapper>
          <SideDrawerAddButton onClick={() => navigate('/goals/add')}>
            + Add a new goal
          </SideDrawerAddButton>
        </SideDrawerButtonWrapper>
      )}
    </div>
  )
}

export default withRouterProps(inject('store')(observer(SideDrawerGoals)))
